import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faStarHalf } from '@fortawesome/pro-solid-svg-icons';

interface IProps {
    keyProp: string | number;
    value : number;
}

const RatingStars = ({keyProp, value}: IProps) => {

    if(!value) return;

    const aScore: any = value.toString().split('.'); 
    const stars = [];

    for (let i = 0; i < aScore[0]; i++) {
        stars.push(
            <FontAwesomeIcon 
                key={`fullstar-${keyProp}-${i}`}
                icon={faStar} 
                color="#facc15" 
            />
        );
    }

    if (aScore[1]) {
        stars.push(
            <FontAwesomeIcon 
                key={`ahlfstar-${keyProp}`}
                icon={faStarHalf} 
                color="#facc15" 
            />
        );
    }
    
    return (
        <div key={Math.random()} className="h-5 flex items-center gap-0.5 [&>svg]:text-lg">
            { stars }
            <span className="ms-1 leading-none relative top-px">
                { value }
            </span>
        </div>
    );
};

export default RatingStars;

